import { DonorType } from 'gql/types';

export const donorTypes = Object.values(DonorType).map((value) => {
  return {
    value,
    label: value,
  };
});
